import { render, staticRenderFns } from "./CheckHeader.vue?vue&type=template&id=256329b2&scoped=true"
var script = {}
import style0 from "./CheckHeader.vue?vue&type=style&index=0&id=256329b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256329b2",
  null
  
)

export default component.exports